import { BNStack, BNRichText } from "@bn-monorepo/js-packages";
import { Paper, Avatar, Typography } from "@mui/material";
import Media from "../../../../CmsComponents/Media/Media";
import { ArticleAuthor } from "../../SectionPage";

interface Props {
  articleAuthor?: ArticleAuthor;
}

export const Author: React.FC<Props> = ({ articleAuthor }) => {
  if (!articleAuthor) {
    return null;
  }
  const { photo, name, biography } = articleAuthor;
  return (
    <BNStack
      component={Paper}
      direction={"row"}
      sx={{
        gap: 1,
        borderRadius: 2,
        p: 2,
      }}
    >
      {photo && (
        <Avatar sx={{ width: "4.8rem", height: "4.8rem" }}>
          <Media AltText={name ?? ""} imagePath={photo.url} noWrapper={true} width={48} height={48} maxWidth={96} />
        </Avatar>
      )}
      <BNStack>
        <Typography
          sx={{
            fontWeight: "bold",
          }}
        >
          {name}
        </Typography>
        <BNRichText html={biography} />
      </BNStack>
    </BNStack>
  );
};
